import { Pill } from "@src/appV2/redesign/system/ui-components";

export function InstantPayPill() {
  return (
    <Pill
      size="medium"
      label="Instant Pay"
      color={(theme) => theme.palette.instantPay?.text}
      backgroundColor={(theme) => theme.palette.instantPay?.background}
      iconColor={(theme) => theme.palette.instantPay?.text}
    />
  );
}
